import { setVisible, OTPCodeValidFormat } from "../helpers"

//@ts-ignore
import { VanillaOTP } from "../../libs/index.js"
import { type SessionCreateResponse } from "../models/session-create-response"
import type { AuthService } from "../services/auth.service"
import { i18n } from "../../internationalize/i18n.service.js"

export class OTPDiag {
  sendBtn: HTMLButtonElement | null = null
  errorElem: HTMLElement
  successElem: HTMLElement
  OTPInputs: Array<HTMLInputElement>
  email: string | null = null
  emailElem: HTMLSpanElement
  existingUser: boolean | null = null
  autoCloseIntervalID: number | null = null

  constructor(
    private element: HTMLElement,
    private loginSuccessCallback: Function,
    private authService:AuthService = window.tbwServices.authService
  ) {
    const errorElem = this.element.querySelector<HTMLElement>('.otp-error-container')
    const successElem = this.element.querySelector<HTMLElement>('.otp-success-container')
    const OTPInputs = Array.from<HTMLInputElement>(this.element.querySelectorAll('.otp-input'))
    const emailElem = element.querySelector('#otp-send-email') as HTMLSpanElement
    const resendBtn = element.querySelector('#resendBtn') as HTMLButtonElement
    
    const elementMissing = !errorElem || !successElem || !OTPInputs || !resendBtn
    if (elementMissing) { throw new Error('Element(s) missing') }

    this.errorElem = errorElem
    this.successElem = successElem
    this.OTPInputs = OTPInputs
    this.emailElem = emailElem
    let resendEmailTimeId: any;
    resendBtn.addEventListener('click', () => {
      clearInterval(resendEmailTimeId)
      resendEmailTimeId = setTimeout(() => this.authService.sendEmail(this.email as string), 5000)
    })

    const hiddenInput = this.element.querySelector("#otpHidden") as HTMLInputElement
    hiddenInput.hidden = true
    const otp = new VanillaOTP(
      this.element.querySelector('.otp-container'),
      hiddenInput,
      (_e: Event) => this.onOTPInputChanged(otp.getValue())
    )
  }

  onOTPInputChanged(otpCode: string) {
    if ((+otpCode).toString().length === 6) { this.send() }
  }

  open(email: string) {
    this.OTPInputs.forEach(i => { i.disabled = false; i.value = '' })
    this.email = email
    setVisible(this.successElem, false)
    setVisible(this.errorElem, false)
    this.emailElem.innerText = this.email
  }

  clear() { this.OTPInputs.forEach(i => i.value = '') }

  parseOTPInputs = (inputs: Array<HTMLInputElement>) => +inputs.map(i => i.value).reduce((a, b) => a + b)

  send = async () => {
    const OTPCode = this.parseOTPInputs(this.OTPInputs)
    if (!OTPCodeValidFormat(OTPCode)) { return false }

    this.OTPInputs.forEach(i => i.disabled = true)
    setVisible(this.errorElem, false)

    const session = await this.authService.verifyOTP(this.email as string, OTPCode)
    session ? this.onOTPValidResponse(session) : this.onOTPInvalidResponse()
  }

  onOTPInvalidResponse = () => {
    const errorMessage = this.errorElem.querySelector("#error-message") as HTMLParagraphElement
    if(!errorMessage) { return }
    errorMessage.innerText = i18n.t("otp_error") ?? "An error occurred while verifying the OTP. Please try again."

    this.errorElem.style.display = 'flex';
    this.errorElem.hidden = false
    const setInvalidAndEnabled = (i: HTMLInputElement) => { i.classList.add('invalid'); i.classList.remove('valid'); i.disabled = false }
    this.OTPInputs.forEach(setInvalidAndEnabled)
    this.OTPInputs[this.OTPInputs.length - 1].focus()
  }

  onOTPValidResponse = (session: SessionCreateResponse) => {
    setVisible(this.successElem, true)
    const setValid = (i: HTMLElement) => { i.classList.add('valid'); i.classList.remove('invalid') }
    this.OTPInputs.forEach(setValid)
    this.loginSuccessCallback(session)
  }
}
